var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wordcloud-container"},[_c('div',{staticClass:"wordcloud-outer"},[_c('div',{staticClass:"wordcloud-inner",style:({
        transformOrigin: '0 0',
        transform: ("translate(" + (_vm.transform.x) + "px," + (_vm.transform.y) + "px)scale(" + (_vm.transform.k) + ")")
      })},_vm._l((_vm.words.filter(function (d) { return d.value.count > 0; })),function(d){return _c('span',{key:d.key,staticClass:"word",style:({
          fontSize: ((Math.sqrt(d.value.count) * _vm.sizeFactor) + "px"),
          color: _vm.color(d.key),
          opacity: _vm.opacity(d.key) ? 0.3 : 1,
          cursor: 'pointer'
        }),on:{"click":function($event){return _vm.onClick(d, $event)},"contextmenu":function($event){return _vm.onRightClick(d, $event)}}},[_vm._v(" "+_vm._s(d.key)+" ")])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }